import axios from 'axios'

export const Post = (r, rt, data) => {
  let formData = new FormData()
  formData.append('p', data)

  return new Promise((resolve, reject) => {
    let url = 'https://api.webhr.co'
    // url = 'http://192.168.86.46/api'

    axios({
      method: 'post',
      url: `${url}/?r=${r}&debug=0&rt=${rt}`,
      data: formData,
    })
      .then((sResponse) => {
        resolve(sResponse)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
